import { HashRouter } from 'react-router-dom';
import initRouter from './router';
import HHeader from '@/components/HHeader';
import { isEnv } from '@/utils';
const App = () => {
  return (
    <HashRouter>
      {isEnv() === 'App' && <HHeader />}
      {initRouter()}
    </HashRouter>
  );
};
export default App;
